import React, { useEffect, useMemo, useState } from "react";

import moment from "moment";

import InfiniteScroll from "react-infinite-scroll-component";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { useLocation, useNavigate } from "react-router-dom";

import { useUser, usePopup, useData, useMenu, useLoading, useLang } from "../zustand/store.js";
import { LangText } from "../zustand/dict.js";

import images from "../libs/images";
import consts from "../libs/consts";
import { img_list } from "../libs/dummy";
import * as APIS from "../utils/service.js"

import Button from "../components/Button";
import GalleryItem from '../components/GalleryItem';

import { randomNumberCreate, shuffleArray } from "../utils/utils";
import ArtDetailPopup from "../components/ArtDetailPopup.js";
import Modal from "../components/Modal.js";

export default function Main() {

    const location = useLocation();
    const navigate = useNavigate();

    const { bears, token, options, isReload, reload, setData, addABear } = useUser();
    const { open, title, popOpen, popClose } = usePopup();
    const { getMenu } = useMenu();
    const { setLoading } = useLoading();
    const { getLang } = useLang();

    const [list, setlist] = useState([]);
    const [page, setPage] = useState(1);
    const [detailOpen, setDetailOpen] = useState(false);

    const [photoList, setPhotoList] = useState([]);
    const [photoInfo, setPhotoInfo] = useState(null);

    useEffect(() => {
        dataFunc();
    }, [])

    const galleryItemClick = (data) => {
        console.log("🚀 ~ galleryItemClick ~ data:", data)
        setPhotoInfo(data);
        setLoading(true)
        setTimeout(() => {
            setLoading(false);
            setDetailOpen(true);
        }, 300)
    }

    const dataFunc = async () => {
        // console.log('dataFunc!!', page + 1);
        // let list_dummy = await img_list();

        // setlist((prev) => [...prev, ...list_dummy]);
        // setPage((prevPage) => prevPage + 1);
    }

    const loadPhotoList = () => {
        APIS.post('/arts/list', {}).then(({ data }) => {
            setPhotoList(data)
        }).catch((e) => {
            console.log(e.response.data);
        });
    }

    const likeFunc = (artIdx, like) => {
        if (!token) {
            setModal({
                ...modal,
                open: true,
                message: getLang({ key: "error_login" })
            })
            return
        }
        console.log(artIdx, like);
        // return

        APIS.post('/arts/like', {
            type: "image",
            artId: artIdx,
            like: like
        }).then(({ data }) => {
            setPhotoList(v => {
                let findIndex = v.findIndex(photo => {
                    return photo.art.idx == artIdx
                })
                console.log("🚀 ~ findData ~ findData:", v[findIndex])
                v[findIndex].art.myLike = like;
                return [...v]
            })
        }).catch((e) => {
            console.log(e.response.data);
        });
    }

    useEffect(() => {
        loadPhotoList();
    }, [])

    const [modal, setModal] = useState(consts.defaultModalValue)

    const modalConfirm = () => {
        if (modal.type === "test") {

        } else {
            modalClose();
        }
    }

    const modalClose = () => {
        setModal(consts.defaultModalValue)
    }
    return (
        <>
            <Modal
                open={modal.open}
                setOpen={(v) => {
                    setModal({ ...modal, open: v })
                }}
                title={modal.title}
                message={modal.message}
                onConfirm={modalConfirm}
                onCancel={modal.isClose ? () => { modalClose(); } : null}
            />

            <div className="content">
                <div className="title_box2">
                    <p className="title"><LangText id={'text_gallery'} /></p>
                    <p className="sub_title"><LangText id={'info_gallery'} /></p>
                </div>

                <div className="gallery_box">
                    <InfiniteScroll
                        dataLength={photoList.length}
                        // next={loadPhotoList}
                        hasMore={true}
                    // loader={<div style={{
                    //     display: "flex",
                    //     alignItems: "center",
                    //     justifyContent: "center",
                    //     width: "100%",
                    //     height: 150,
                    // }}>
                    //     <div className="loader9" />
                    // </div>}
                    >
                        <ResponsiveMasonry
                            columnsCountBreakPoints={{ 500: 2, 700: 3, 1024: 4 }}
                        >
                            <Masonry
                                gutter="4px"
                            >
                                {photoList.map((x, i) => {
                                    return (
                                        <GalleryItem
                                            key={i}
                                            title={x.art?.user?.name}
                                            item={{
                                                height: x?.art?.height ? x?.art?.height : 1024,
                                                // ratio: x?.art?.height ? `${x?.art?.width}/${x?.art?.height}` : 1,
                                                src: `${consts.imgUrl}${x?.art?.files[0]?.filePath}`
                                            }}
                                            onClick={() => {
                                                galleryItemClick(x);
                                            }}
                                            like={x.art?.myLike}
                                            setLike={() => {
                                                likeFunc(x.art?.idx, !x.art?.myLike)
                                            }}
                                        />
                                    );
                                })}
                            </Masonry>
                        </ResponsiveMasonry>
                    </InfiniteScroll>
                </div>
            </div>

            <ArtDetailPopup
                open={detailOpen}
                setOpen={setDetailOpen}
                data={photoInfo}
                likeClick={() => {
                    likeFunc(photoInfo.art?.idx, !photoInfo.art?.myLike)
                }}
            />
        </>
    );
}
